const sw = self as unknown as ServiceWorkerGlobalScope;

const cacheName = 'cache-v1';

sw.addEventListener('install', () => {
  console.log('Service worker install event!');
});

sw.addEventListener('activate', () => {
  console.log('Service worker activate event!');
  return sw.clients.claim();
});

async function networkFirst(request: Request) {
  try {
    const networkResponse = await fetch(request);
    if (networkResponse.ok) {
      const cache = await caches.open(cacheName);
      cache.put(request, networkResponse.clone());
    }
    return networkResponse;
  } catch (error: unknown) {
    console.log("Fetch failed; returning cached response", error);
    const cachedResponse = await caches.match(request);
    return cachedResponse || Response.error();
  }
}

sw.addEventListener("fetch", (event) => {
  const url = new URL(event.request.url);
  if (url.origin === location.origin) {
    console.log("Fetching", url.pathname);
    event.respondWith(networkFirst(event.request));
  }
});

export { }